<template>
    <div class="numeric-container" :class="{ $mq }">
        <template v-if="isSensor">
            <div class="sensor-content">
                <!-- READING -->
                <template v-if="isSensor && readingSensor && sensorStatus == 'waiting'">
                    <LottieAnimation class="icon waiting" :timeToRepeat="1" :animationName="'sensor.json'" :loopAnimation="true"></LottieAnimation>
                    <div class="text" @click="sensorStatus = 'disconnected'" v-html="getString('popup.numeric.device.waiting')"></div>
                </template>

                <!-- NO DEVICE CONNECTED -->
                <template v-else-if="sensorStatus == 'disconnected'">
                    <!-- <div class="icon disconnected"></div> -->
                    <LottieAnimation class="icon waiting" :timeToRepeat="1" :animationName="'sensor-disconnect.json'" :loopAnimation="true"></LottieAnimation>
                    <div class="text" v-html="getString('popup.numeric.device.disconnected')"></div>
                </template>

                <template v-else-if="sensorStatus == 'connecting_2'">
                    <!-- <div class="icon connecting"></div> -->
                    <LottieAnimation class="icon connecting" :timeToRepeat="1" :animationName="'sensor-bluetooth.json'" :loopAnimation="true"></LottieAnimation>

                    <div class="text" v-html="getString('popup.numeric.device.connecting')"></div>
                </template>

                <!-- DEVICE CONNECTING -->
                <template v-else-if="sensorStatus == 'connecting'">
                    <!-- <div class="icon connecting"></div> -->
                    <LottieAnimation v-if="searching" class="icon connecting" :timeToRepeat="1" :animationName="'sensor-bluetooth.json'" :loopAnimation="true"></LottieAnimation>

                    <div class="text" v-if="searching" v-html="getString('popup.numeric.device.searching_device')"></div>
                    <div class="text" v-if="!searching && devices.length > 0" v-html="getString('popup.numeric.device.select_device')"></div>
                    <div class="step">
                        <ul class="devices list hide-scrollbar">
                            <template v-if="Object.keys(devices).length > 0">
                                <li v-for="dv in devices" :key="dv.id" class="item printer" :class="{ selected: BLEMAC == dv.id }" @click="selectDevice(dv)">
                                    {{ dv.name }}
                                </li>
                            </template>
                            <template v-else>
                                <li v-if="devices.length == 0" class="empty">
                                    {{ getString('config.printer.BLUETOOTH.empty') }}
                                </li>
                            </template>

                            <div v-if="!searching" class="btn-search" :class="{ filled: Object.keys(devices).length > 0 }" @click="searchDevices()">{{ getString('config.printer.refresh') }}</div>
                        </ul>
                    </div>
                </template>

                <!-- DEVICE CONNECTED (Same as waiting) -->
                <!-- <template v-else-if="sensorStatus == 'connected'">
                    <div class="icon connected" @click="readSensor()"></div>
                    <div class="text" @click="sensorStatus = 'error'" v-html="getString('popup.numeric.device.connected')"></div>
                </template> -->

                <!-- DEVICE ERROR -->
                <template v-else-if="sensorStatus == 'error'">
                    <!-- <div class="icon error"></div> -->
                    <LottieAnimation class="icon error" :timeToRepeat="3" :animationName="'sensor-error.json'" :loopAnimation="true"></LottieAnimation>

                    <!-- VOLVER A CONECTAR -->
                    <div class="text" v-html="getString(error_gps ? 'popup.numeric.device.error_gps' : 'popup.numeric.device.error')"></div>
                </template>

                <!-- MEASURE DEVICE FINISH -->
                <template v-else-if="sensorStatus == 'finish'">
                    <div class="value">{{ formatDisplayNumber(value) }} {{ mesure }}</div>
                </template>
            </div>

            <div class="change-mode">
                <template v-if="isSensor && sensorStatus == 'finish'">
                    <div class="button" @click="erraseValue()">{{ getString('popup.numeric.device.delete_value') }}</div>
                    <div class="button" @click="readSensor()">{{ getString('popup.numeric.device.retake_sensor') }}</div>
                </template>
                <template v-else>
                    <div v-if="sensorStatus == 'disconnected'" class="button" @click="launchBLESensor()">{{ getString('popup.numeric.device.reconnect') }}</div>
                    <div v-if="sensorStatus == 'error' || sensorStatus == 'connecting_2' || sensorStatus == 'waiting'" class="button" @click="startForcedTemperatureScan()">{{ getString('popup.numeric.device.scan_devices') }}</div>
                    <div v-if="this.sensorType != 'sensor'" class="button" @click="swapToManual()">{{ getString('popup.numeric.device.switch_manual') }}</div>
                    <div v-if="BLEMAC && sensorStatus == 'connecting'" class="button main" @click="connectDevice()">{{ getString('popup.numeric.device.connect') }}</div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="numpad-container" :class="[$mq]" :style="{ width: '100%' }">
                <div class="max-exceeded" v-if="max && !newDesing" v-html="getString('label.max_exceeded', { s: max })" :class="{ hide: !maxExceeded }"></div>
                <div class="numpad-error" v-if="!isQuantity && isInvalidValue">
                    <span>{{ invalidValueMessage }}</span>
                </div>
                <div class="num-padtop" v-if="!hasNegative" :class="[{ 'has-quantity': isQuantity }, { 'error-numpad': error }]">
                    <div v-on:click="keyPressOperator('-')" v-if="isQuantity" class="key operator less" :class="{ 'disabled': newDesing && Number(value) <= min }"></div>
                    <input :type="pinType === 'number' ? 'text' : pinType" :disabled="shouldDisableInputForMobile" v-if="pinType != 'password'" class="pin" v-model="compValue" @input="validateInput" ref="refInputVal" :class="{ 'new-desing': newDesing }"/>

                    <div class="password-pin" v-if="pinType == 'password'">
                        <div class="number-key" :class="[{ 'with-value': compValue.charAt(0) }, { 'error-pin': error }]">
                            <div class="circle" v-if="compValue.charAt(0)"></div>
                        </div>
                        <div class="number-key" :class="[{ 'with-value': compValue.charAt(1) }, { 'error-pin': error }]">
                            <div class="circle" v-if="compValue.charAt(1)"></div>
                        </div>
                        <div class="number-key" :class="[{ 'with-value': compValue.charAt(2) }, { 'error-pin': error }]">
                            <div class="circle" v-if="compValue.charAt(2)"></div>
                        </div>
                        <div class="number-key" :class="[{ 'with-value': compValue.charAt(3) }, { 'error-pin': error }]">
                            <div class="circle" v-if="compValue.charAt(3)"></div>
                        </div>
                    </div>
                    <div v-on:click="keyPressOperator('+')" v-if="isQuantity" class="key operator more" :class="{ 'disabled': newDesing && Number(value) >= max }"></div>
                </div>
                <div class="num-padtop" v-else-if="hasNegative" :class="[{ 'error-numpad': error }]">
                    <div v-if="hasNegative" v-on:click="keyPolarity()" class="key negative-positive"></div>
                    <input :type="pinType === 'number' ? 'text' : pinType" :disabled="shouldDisableInputForMobile" v-if="pinType != 'password'" class="pin" v-model="compValue" @input="validateInput" ref="refInputVal"/>
                </div>
                <div class="num-padtop" v-else :class="[{ 'error-numpad': error }]">
                    <input :type="pinType === 'number' ? 'text' : pinType" :disabled="shouldDisableInputForMobile" v-if="pinType != 'password'" class="pin" v-model="compValue" @input="validateInput" ref="refInputVal"/>
                </div>
                <div class="num-pad">
                    <div v-on:click="keyPress(7)" class="key numberkey">7</div>
                    <div v-on:click="keyPress(8)" class="key numberkey">8</div>
                    <div v-on:click="keyPress(9)" class="key numberkey">9</div>
                    <div v-on:click="keyPress(4)" class="key numberkey">4</div>
                    <div v-on:click="keyPress(5)" class="key numberkey">5</div>
                    <div v-on:click="keyPress(6)" class="key numberkey">6</div>
                    <div v-on:click="keyPress(1)" class="key numberkey">1</div>
                    <div v-on:click="keyPress(2)" class="key numberkey">2</div>
                    <div v-on:click="keyPress(3)" class="key numberkey">3</div>
                    <div v-on:click="keyBack" class="key keyback"></div>
                    <div v-on:click="keyPress(0)" class="key numberkey">0</div>
                    <div v-on:click="saveAndClose" class="key save-and-close" v-if="newDesing">
                        <i class="i-andy-done i-andy-m"></i>
                    </div>
                    <div v-on:click="keyPressDecimal('.')" v-if="isDecimal" class="key decimal">{{ decimalSeparator }}</div>
                    <div v-on:click="sendError" v-if="!isDecimal && !newDesing" class="key disabled"></div>
                </div>
                <!--<span v-if="pinType == 'numeric'" class="no-value" @click="saveAndClose">{{ getString('popup.default.no_value') }}</span>-->
            </div>
        </template>
    </div>
</template>

<script>
import { formatNumberLabel } from '@/utils/numberFormat'
import { decimalSeparator, localizeNumberDraft, parseNumberInput } from '@/utils/numberFormat'
import i18n from '@/i18n'
import store from '@/store'
import LottieAnimation from '@/components/layout/LottieAnimation.vue'
import bleTemperaturePeripheral from '@/mixins/bleTemperaturePeripheral'

export default {
    components: { LottieAnimation },
    mixins: [bleTemperaturePeripheral],
    props: {
        error: { type: Boolean, default: false },
        pinType: { type: String, default: 'text' },
        decimal: { type: Boolean, default: false },
        incremental: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        hasNegative: { type: Boolean, default: false },
        max: { type: Number, default: null },
        min: { type: Number, default: null },
        givenValue: { type: undefined, default: '' },
        startNumber: { type: Number, default: -1 },
        quantity: { type: Boolean, default: false },
        newDesing: { type: Boolean, default: false },
        sensorType: { type: String, default: 'manual' },
        preventMobileKeyboard: { type: Boolean, default: true },
    },
    data() {
        return {
            value: this.givenValue,
            isNegative: this.checkNegative(),
            isDecimal: this.decimal,
            isIncremental: this.incremental,
            maxExceeded: false,
            modified: false,
            isInvalidValue: false,
            keys: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', null, '.'],
            devices: [],
            isSensor: this.sensorType == 'all' || this.sensorType == 'sensor' ? true : false,
            readingSensor: true,
            iTOScan: null,
            interval: null,
            BLEMAC: false,
            searching: false,
            BLEServiceSubscribe: '00004590-81b7-4047-8773-00dba7a16acd',
            BLECharacteristicSubscribe: '00004593-81b7-4047-8773-00dba7a16acd',
            BLECharacteristicSubscribe2: '00004592-81b7-4047-8773-00dba7a16acd',
            BLEService: '000035e0-8eb0-4405-a6aa-800f66d02188',
            BLECharacteristic: '000035e3-8eb0-4405-a6aa-800f66d02188',
            BLECharacteristicKEY: '000035e1-8eb0-4405-a6aa-800f66d02188', // WRITE KEY
            BLECharacteristicCMP: '000035e2-8eb0-4405-a6aa-800f66d02188', // WRITE COMPANY
            BLECompany: false,
            BLEPassword: false,
            bluetoothService: '180A',
            sensorStatus: 'disconnected',
            ble_num_errors_subscribe: 0,
            ble_max_errors_subscribe: 3,
            ble_num_errors_connect: 0,
            ble_max_errors_connect: 3,
            ble_num_errors_read: 0,
            ble_max_errors_read: 3,
            ble_num_errors_write: 0,
            ble_max_errors_write: 3,
            error_gps: false,
        }
    },
    computed: {
        decimalSeparator() {
            return decimalSeparator(this.$i18n.locale)
        },
        isDisabled() {
            return this.disabled
        },
        isQuantity() {
            return this.quantity
        },
        invalidValueMessage() {
            return i18n.t('label.invalid_value')
        },
        compValue: {
            get() {
                if (this.startNumber != -1 && this.value == '') {
                    this.value = String(this.startNumber)
                }
                if (this.max != null) {
                    if (this.max < this.value) this.maxExceeded = true
                    else this.maxExceeded = false
                }
                // if (this.min != null && !this.isNegative) {
                //   if (this.min > this.value) {
                //     // this.value = String(this.min);
                //     this.value = "";
                //   }
                // // if (this.min < 0 && this.min != null && !this.isNegative) {
                // //   if (this.min >= this.value) {
                // //     this.value = String(this.min);
                // //   }
                //
                // } else if (this.min != null && this.isNegative) {
                //   if (this.min > String('-' + this.value)) this.value = String(this.min).replace('-', '')
                // }
                return this.pinType === 'password' ? String(this.value) : localizeNumberDraft(this.value, this.$i18n.locale)
            },
            set() {}
        },

        isPositive() {
            return !this.isNegative
        },

        posTop() {
            return '20px'
        },
        positivePosLeft() {
            if (this.$parent.type == 'numeric') {
                if (this.classPositive == 'selected') {
                    return '37px'
                } else {
                    return '-3px'
                }
            } else {
                if (this.classPositive == 'selected') {
                    return '0px'
                } else {
                    return '-40px'
                }
            }
        },
        negativePosLeft() {
            if (this.$parent.type == 'numeric') {
                if (this.classNegative == 'selected') {
                    return '37px'
                } else {
                    return '-3px'
                }
            } else {
                if (this.classNegative == 'selected') {
                    return '0px'
                } else {
                    return '-40px'
                }
            }
        },
        classPositive() {
            if (this.isPositive) return 'selected'
        },
        classNegative() {
            if (this.isNegative) return 'selected'
        },
        isAPP() {
            return process.env.VUE_APP_IS_APP == 'TRUE'
        },
        isDesktop() {
            return !this.isAPP && ['landscape', 'desktop'].includes(this.$mq)
        },
        shouldDisableInputForMobile() {
            if (this.isDesktop) {
                return false
            }
            return this.isAPP || this.preventMobileKeyboard
        }
    },
    methods: {
        formatDisplayNumber(value, fractionDigits) {
            return formatNumberLabel(value, this.$i18n.locale, fractionDigits)
        },
        localizeDraft(value) {
            return localizeNumberDraft(value, this.$i18n.locale)
        },
        keyPolarity(polarity = null) {
            if (!this.isDisabled) {
                // Check the polarity parameter
                if (polarity === true) {
                    this.isNegative = false;
                } else if (polarity === false) {
                    this.isNegative = true;
                } else {
                    this.isNegative = !this.isNegative
                }

                if (this.isNegative) {
                    if (!this.value.startsWith('-')) {
                        this.value = '-' + this.value
                    }
                } else {
                    this.value = this.value.replace('-', '')
                }
            }

            if (this.value && this.value !== '-') {
                this.value = parseFloat(this.value)
                this.value = String(this.value)
            }

            this.compValue = this.value
            this.sendValue()
        },
        keyPress(val) {
            // Validación para no poner más de 4 números en password
            if (this.pinType == 'password' && this.value.length == 4) {
            } else {
                if (!this.isDisabled) {
                    if ((this.value == '0' && this.pinType != 'password') || (this.value == this.startNumber && this.startNumber != -1 && !this.modified) || (this.givenValue == '' && this.startNumber != -1)) {
                        this.value = String(val)
                    } else {
                        this.value = this.value + val
                    }

                    if (!this.modified) this.modified = true
                    this.sendValue()
                }
            }
            if (this.value.length == 4) {
                this.$emit('autoEnter')
            }
        },
        keyPressOperator(val) {
            if (!this.isDisabled) {
                switch (val) {
                    case '+':
                        if(!this.max && this.value || this.value < this.max) {
                            this.value = String(Number(this.value) + 1)
                        }
                        break
                    case '-':
                        if (!this.min && this.value || this.value > this.min) {
                            this.value = String(Number(this.value) - 1)
                        }
                        break
                }
                this.sendValue()
            }
        },
        keyPressDecimal(val) {
            if (!this.isDisabled) {
                if (this.value.indexOf(val) == -1) {
                    this.value = this.value + val
                }
                this.sendValue()
            }
        },
        keyBack() {
            if (!this.isDisabled) {
                this.value = String(this.value).slice(0, -1)
                this.sendValue()
            }
        },
        keyPolarity() {
            if (!this.isDisabled) {
                this.isNegative = !this.isNegative
                if (this.isNegative) {
                    this.value = '-' + this.value
                } else {
                    this.value = this.value.toString().replace('-', '')
                }
            }

            if (this.value && this.value != '-') {
                this.value = parseFloat(this.value)
                this.value = String(this.value)
            }
            this.sendValue()
        },

        saveAndClose() {
            if(this.newDesing) {
                this.$emit('sendValue', this.value)
                this.$emit('saveAndClose')
            } else {
                this.$emit('sendValue', '-')
                this.$emit('saveAndClose')
            }
        },

        sendValue(bFromSensor = false) {
            this.isInvalidValue = false
            if (this.max != null) {
                if (this.max < this.value) {
                    this.maxExceeded = true
                    this.value = this.max
                } else {
                    this.maxExceeded = false
                }
            }
            if (!isNaN(this.value)) {
                if (this.isNegative) {
                    this.$emit('sendValue', this.value, bFromSensor)
                } else {
                    if (this.startNumber != -1) {
                        this.value = Number(this.value) < this.startNumber ? String(0) : this.value
                    }
                    this.$emit('sendValue', this.value, bFromSensor)
                }
            } else {
            }
        },
        sendError(e) {
            this.$emit('sendError', 'hola')
        },

        checkNegative: function () {
            if (this.value) {
                this.isNegative = String(this.value).indexOf('-') != -1
                return this.isNegative
            } else {
                this.isNegative = false
                return this.isNegative
            }
        },

        getString(str, params = {}) {
            return i18n.t(str, params)
        },
        getStringPlural(str, pos) {
            return i18n.tc(str, pos)
        },
        validateInput(val) {
            if (this.pinType !== 'password' && val.inputType === 'insertFromPaste') {
                const numeric = parseNumberInput(val.target.value, this.$i18n.locale)
                if (numeric === null || (!this.isDecimal && !Number.isInteger(numeric))) {
                    this.isInvalidValue = true
                    val.target.value = this.compValue
                    return
                }
                this.value = String(numeric)
                this.modified = true
                this.sendValue()
                return
            }
            if (val.data === this.decimalSeparator) val = { data: '.' }

            if (!this.keys.includes(val.data)) {
                this.isInvalidValue = true
                return
            }

            switch (val.data) {
                case null:
                    this.keyBack()
                    break
                case '.':
                    if (this.isDecimal) {
                        this.keyPressDecimal('.')
                    } else {
                        this.isInvalidValue = true
                    }
                    break
                default:
                    this.keyPress(val.data)
                    break
            }
        },
        load() {
            this.applySavedTemperaturePeripheral()
            const sensorBluetoothConnection = store.getters.getSensorBluetoothConnection
            if(sensorBluetoothConnection) {
                this.BLECompany = sensorBluetoothConnection.cmp ? sensorBluetoothConnection.cmp : false
                this.BLEPassword = sensorBluetoothConnection.key ? sensorBluetoothConnection.key : false
            }
            
            if (!(this.sensorType == 'all' || this.sensorType == 'sensor')) {
                // SI VALOR YA DEFINIDO MOSTRAR PANTALLA CON EL VALOR
                // SIN VALOR DEFINIDO, MOSTRAR PANTALLA DE CONECTING + llamar a la funcion readSensor
                this.updateSensorStep(4)
            } else {
                if (this.value) {
                    this.sensorStatus = 'finish'
                    this.updateSensorStep(2)
                } else {
                    this.sensorStatus = 'connecting'
                    this.readSensor()
                    this.updateSensorStep(3)
                }
            }
        },
        // SENSOR METHODS
        readDataFromSubscribe(data) {
            log('BLE READ FROM SUBSCRIBE:', data)
            this.ble_num_errors_subscribe = 0

            if (data) {
                var msg = bytesToString(data)
                this.sensorStatus = 'finish'

                //END BLE SENSOR LOGIC
                if (this.isSensor) {
                    this.value = msg.split(' ')[0]
                    this.readingSensor = false
                    this.updateSensorStep(2)
                    this.sendValue(true)
                }
            }
        },
        unsubscribeBLE(callback) {
            var self = this

            if (this.BLEMAC) {
                if (typeof ble !== 'undefined') {
                    ble.stopNotification(
                        self.BLEMAC,
                        self.BLEServiceSubscribe,
                        self.BLECharacteristicSubscribe2,
                        function () {
                            log('Device unsubscribed...')
                            if (typeof callback === 'function') {
                                callback()
                            }
                        },
                        function (err) {
                            console.error('ERROR UNSUBSCRIBE', err)
                            if (err) {
                                if (typeof callback === 'function') {
                                    callback()
                                }
                            } else if (self.ble_num_errors_subscribe < self.ble_max_errors_subscribe) {
                                self.ble_num_errors_subscribe++
                                // self.unsubscribeBLE()
                            } else {
                                self.sensorStatus = 'error'
                            }
                        }
                    )
                } else if (typeof callback === 'function') {
                    callback()
                }
            } else if (typeof callback === 'function') {
                callback()
            }
        },
        subscribeBLE() {
            var self = this
            this.ble_num_errors_read = 0
            this.sensorStatus = 'waiting'
            this.markTemperatureDeviceReady()
            if (typeof ble !== 'undefined') {
                ble.startNotification(self.BLEMAC, self.BLEServiceSubscribe, self.BLECharacteristicSubscribe2, self.readDataFromSubscribe, function (err) {
                    console.error('ERROR SUBSCRIBE', err)
                    if (err.error == 'isDisconnected') {
                    } else if (self.ble_num_errors_subscribe < self.ble_max_errors_subscribe) {
                        self.ble_num_errors_subscribe++
                        self.signBLE()
                    } else {
                        self.sensorStatus = 'error'
                    }
                })
            } else {
                self.sensorStatus = 'error'
            }
        },
        signBLE() {
            var self = this

            if (typeof ble !== 'undefined') {
                ble.read(
                    self.BLEMAC,
                    self.BLEService,
                    self.BLECharacteristic,
                    function (data) {
                        var msg = bytesToString(data)
                        console.error('BLE READ', msg)
                        if (data) {
                            if (msg == 'KEY_VALID') {
                                self.sensorStatus = 'connecting_2'
                                self.subscribeBLE()
                            } else if (msg == 'KEY_INVALID' || msg == 'WAIT_KEY') {
                                // WRITE KEY
                                let utf8Encode = hexa_to_decimal(self.BLEPassword)
                                log(utf8Encode.buffer)
                                ble.write(
                                    self.BLEMAC,
                                    self.BLEService,
                                    self.BLECharacteristicKEY,
                                    utf8Encode.buffer,
                                    function (data) {
                                        log('KEY sended')
                                        self.signBLE()
                                    },
                                    function (err) {
                                        console.error('ERROR WRITE', err)
                                        if (self.ble_num_errors_read < self.ble_max_errors_read) {
                                            self.ble_num_errors_read++
                                            self.signBLE()
                                        } else {
                                            self.sensorStatus = 'error'
                                        }
                                    }
                                )
                            } else if (msg == 'COMPANY_INVALID' || msg == 'WAIT_COMPANY') {
                                //WRITE COMPANY
                                let utf8Encode = ascii_to_decimal(self.BLECompany)
                                log(utf8Encode.buffer)
                                ble.write(
                                    self.BLEMAC,
                                    self.BLEService,
                                    self.BLECharacteristicCMP,
                                    utf8Encode.buffer,
                                    function (data) {
                                        log('Company sended')
                                        self.signBLE()
                                    },
                                    function (err) {
                                        console.error('ERROR WRITE', err)
                                        if (self.ble_num_errors_read < self.ble_max_errors_read) {
                                            self.ble_num_errors_read++
                                            self.signBLE()
                                        } else {
                                            self.sensorStatus = 'error'
                                        }
                                    }
                                )
                            }
                        } else {
                            if (self.ble_num_errors_read < self.ble_max_errors_read) {
                                self.ble_num_errors_read++
                                self.signBLE()
                            } else {
                                self.sensorStatus = 'error'
                            }
                        }
                    },
                    function (err) {
                        console.error('ERROR READ', err)
                        if (self.ble_num_errors_read < self.ble_max_errors_read) {
                            self.ble_num_errors_read++
                            self.signBLE()
                        } else {
                            self.sensorStatus = 'error'
                        }
                    },
                    {
                        address: self.BLEMAC,
                        service: self.BLEService,
                        characteristic: self.BLECharacteristic
                    }
                )
            } else {
                self.sensorStatus = 'error'
            }
        },
        disconnectBLE(callback) {
            var self = this
            if (this.BLEMAC) {
                if (typeof ble !== 'undefined') {
                    ble.disconnect(
                        self.BLEMAC,
                        function (data) {
                            log('DisconnectBLE - disconnected')
                            if (typeof callback === 'function') {
                                callback()
                            }
                        },
                        function (err) {
                            console.error('ERROR DISCONNECT', err)
                            if (self.ble_num_errors_connect < self.ble_max_errors_connect) {
                                self.ble_num_errors_connect++
                                self.disconnectBLE(callback)
                            } else if (typeof callback === 'function') {
                                callback()
                            } else {
                                self.sensorStatus = 'error'
                            }
                        }
                    )
                } else if (typeof callback === 'function') {
                    callback()
                }
            } else if (typeof callback === 'function') {
                callback()
            }
        },
        connectBLE() {
            var self = this
            const attemptId = this.connectAttemptId
            this.pendingConnectAddress = this.BLEMAC
            if (typeof ble !== 'undefined') {
                ble.connect(
                    this.BLEMAC,
                    function (data) {
                        log('BLE Connect:', data)
                        if (!self.handleTemperatureConnectSuccess(attemptId, data)) {
                            return
                        }
                        if (data && data.name) {
                            self.BLEDeviceName = data.name
                        }
                        self.persistCurrentTemperaturePeripheral()
                        self.sensorStatus = 'connecting_2'
                        self.signBLE()
                    },
                    function (err) {
                        log('ERROR CONNECT', err)
                        if (self.handleTemperatureConnectFailure(attemptId)) {
                            return
                        }
                        if (self.ble_num_errors_connect < self.ble_max_errors_connect) {
                            self.ble_num_errors_connect++
                            self.connectBLE()
                        } else {
                            self.sensorStatus = 'error'
                        }
                    }
                )
            } else {
                self.sensorStatus = 'error'
            }
        },
        connectDevice() {
            this.beginManualTemperatureConnect()
            this.persistCurrentTemperaturePeripheral()
            this.sensorStatus = 'connecting_2'
            this.connectBLE()
        },
        selectDevice(sensor) {
            log('Connecting to ', sensor)
            this.BLEMAC = sensor.id
            this.BLEDeviceName = sensor.name || ''
        },
        detectDeviceBLE(data) {
            log('Device detected', data)
            var self = this
            if (data) {
                let devices = [...this.devices]
                devices.push(data)
                this.devices = [...devices]
            }
        },
        stopScanBLE(callback) {
            log('stopScanBLE - init')
            clearTimeout(this.iTOScan)
            if (typeof ble !== 'undefined') {
                ble.stopScan(
                    function () {
                        log('Stop scanning...')
                        if (typeof callback === 'function') {
                            log('Launching callback stop')
                            callback()
                        }
                    },
                    function (err) {
                        log('Error stop scanning', err)
                        if (typeof callback === 'function') {
                            callback()
                        }
                    }
                )
            } else if (typeof callback === 'function') {
                callback()
            }
        },
        scanBLE() {
            var self = this
            log('Start scanning...')
            const timeLimitScan = 10
            this.searching = true
            this.devices = []

            if (this.BLEMAC) {
                this.beginManualTemperatureConnect()
                this.connectBLE()
            } else if (ble){
                ble.scan([this.bluetoothService], 10, self.detectDeviceBLE, function (err) {
                    log('ERROR Scanning...', err)
                    self.stopScanBLE()
                    self.sensorStatus = 'error'
                })
                // let i = 1
                // this.interval = setInterval(() => {
                //     self.detectDeviceBLE({
                //         name: 'TI SensorTag ' + i,
                //         id: 'BD922605-1B07-4D55-8D09-B66653E51BBA' + i
                //     })
                //     i++
                // }, 3000)

                this.iTOScan = setTimeout(
                    function (self2) {
                        log('Time limit scan...')
                        self2.searching = false
                        self2.stopScanBLE()
                        if (self2.devices.length == 0) {
                            self2.sensorStatus = 'error'
                        }
                        clearInterval(self2.interval)
                    },
                    timeLimitScan * 1000,
                    this
                )
            } else {
                this.searching = false
                self2.stopScanBLE()
                if (this.devices.length == 0) {
                    this.sensorStatus = 'error'
                }
            }
        },
        launchBLESensor(bTryToConnect) {
            log('LaunchBLESensor...')
            var self = this
            bTryToConnect = typeof bTryToConnect === 'undefined' ? true : bTryToConnect
            if (typeof ble !== 'undefined') {
                ble.isEnabled(
                    function () {
                        ble.isLocationEnabled(
                            function () {
                                self.sensorStatus = 'connecting'
                                self.ble_num_errors_subscribe = 0
                                self.ble_num_errors_connect = 0
                                self.ble_num_errors_read = 0
                                self.ble_num_errors_write = 0
                                self.error_gps = false

                                if (self.shouldAutoConnectSavedDevice()) {
                                    self.stopScanBLE(() => {
                                        self.unsubscribeBLE(() => {
                                            self.disconnectBLE(() => {
                                                self.connectToSavedTemperatureDevice()
                                            })
                                        })
                                    })
                                } else {
                                    self.forceScan = false
                                    self.stopScanBLE(self.scanBLE)
                                }
                            },
                            function () {
                                log('location services are *not* enabled')
                                self.error_gps = true
                                self.sensorStatus = 'error'
                            }
                        )
                    },
                    function () {
                        if (bTryToConnect) {
                            ble.enable(
                                function () {
                                    log('Bluetooth is enabled')
                                    self.launchBLESensor(false)
                                },
                                function () {
                                    self.launchBLESensor(false)
                                }
                            )
                        } else {
                            log('Bluetooth is *not* enabled')
                            self.sensorStatus = 'error'
                        }
                    }
                )
            } else {
                self.sensorStatus = 'error'
            }
        },

        searchDevices() {
            var self = this
            self.stopScanBLE(self.scanBLE)
        },

        async readSensor() {
            this.updateSensorStep(1)
            this.isSensor = true
            this.readingSensor = true

            //START BLE SENSOR LOGIC
            this.launchBLESensor()
        },

        erraseValue() {
            this.value = ''
            this.sendValue()
            this.$emit('saveAndClose')
        },

        updateSensorStep(step) {
            log('updateSensorStep', step)
            this.$emit('updateSensorStep', step)
        },

        swapToManual() {
            var self = this
            log('swapToManual')
            this.stopScanBLE(() => {
                log('stopScanBLE')
                self.unsubscribeBLE(() => {
                    log('unsubscribeBLE')
                    self.disconnectBLE(function () {
                        log('disconnectBLE')
                        self.updateSensorStep(2)
                        self.isSensor = false
                    })
                })
            })
        },
    },
    created() {
        log('numeric created', this.sensorType)
        this.load()
    },
    mounted() {
        this.checkNegative()
    },
    beforeDestroy() {
        var self = this
        if ((this.sensorType == 'all' || this.sensorType == 'sensor') && typeof ble !== 'undefined') {
            this.stopScanBLE(() => {
                self.unsubscribeBLE(self.disconnectBLE)
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.numeric-container {
    @include flex-direction(column);
    position: relative;
    $key-size: rem(60px);
    $topkey-size: rem(60px);
    width: 100%;

    @include flex-direction(column);
    position: relative;
    $key-size: rem(60px);
    $topkey-size: rem(60px);
    width: 100%;

    .sensor-content {
        @include display-flex();
        @include align-content();
        @include align-items();
        @include justify-content();
        @include flex-direction(column);
        #app.icon {
            margin: 25px auto;
            height: 150px;
            width: 150px;
        }

        .icon {
            margin: 25px auto;
            height: 150px;
            width: 150px;

            &.disconnected {
                @include background($image: img('circle_exclamation_accent.svg'), $size: 120px);
            }

            &.connecting {
                @include background($image: img('loader_primary.svg'), $size: 120px);
            }

            &.connected {
                @include background($image: img('checked_ok.svg'), $size: 120px);
            }

            &.error {
                @include background($image: img('error_alert.svg'), $size: 120px);
            }
        }

        .text {
            @include font-size(ml);
            font-family: $text;
            color: $neutro-s80;
            text-align: center;
            margin-bottom: 50px;
        }

        .value {
            @include font-size(46px);
            margin: 50px auto;
            color: $neutro-s80;
            font-family: $text-bold;
        }
    }

    .step {
        @include display-flex();
        @include justify-content();
        @include flex-wrap(wrap);
        min-height: 60px;

        .devices {
            width: 100%;
            max-width: 350px;
            margin: 0 auto;
            margin-top: 25px;
            max-height: 600px;
            overflow: auto;

            .meta {
                @include display-flex();
                @include justify-content();
                @include align-items();
                margin-bottom: 10px;
                width: 100%;
                text-align: center;

                .label {
                    @include display-flex();
                    @include justify-content();
                    @include align-items();
                    height: 30px;
                }
            }
            .btn-search {
                @include border-radius(3px);
                @include display-flex();
                @include justify-content();
                @include align-items();
                @include font-size(m);
                @include background($image: img('reload_main_s30.svg'), $size: 20px, $position: left 10px center);
                background-color: $neutro;
                height: 40px;
                cursor: pointer;
                padding: 6px 9px;
                padding-left: 40px;
                margin: 15px auto 0;
                width: fit-content;
                font-family: $text;
                color: $main-s50;

                &.filled {
                    background-image: img('reload_neutro_s70.svg');
                    background-color: transparent;
                    color: $neutro-s70;
                }
            }

            .item {
                @include background($image: img('unchecked_filled.svg'), $size: 20px, $position: left 10px center);
                @include border-radius(6px);
                @include interaction();
                @include font-size(m);
                padding: 10px 15px;
                color: $neutro-s70;
                width: 100%;
                margin: 10px auto;
                font-family: $text-bold;
                background-color: #ece1e0;
                padding-left: 40px;

                &.selected {
                    @include background($image: img('checked_main.svg'), $size: 20px, $position: left 10px center);

                    .meta {
                        font-family: $text-bold;
                        color: $main;
                    }
                }
            }
        }
    }

    &.portrait {
        $key-size: rem(50px);
    }

    .change-mode {
        @include display-flex();
        @include align-items();
        @include flex-direction(row);
        @include flex-wrap(wrap);
        @include justify-content(space-between);
        width: auto;
        max-width: 100%;
        height: auto;
        text-align: right;
        margin-top: 20px;

        .button {
            @include display-flex();
            @include align-items();
            @include justify-content();
            @include border-radius(4px);
            @include font-size(m);
            border: 1px solid rgba(131, 131, 131, 0.03);
            height: auto;
            margin: 6px auto;
            padding: 0 20px;
            color: $main;
            font-family: $text-light;
            background-color: $main-t90;
            min-height: 50px;
            overflow: hidden;
            cursor: pointer;
            text-align: center;

            &.main {
                background-color: $main;
                color: #fff;
                font-family: $text-bold;
            }
        }
    }
}

.numpad-container {
    $key-size: rem(60px);
    $topkey-size: rem(60px);

    position: relative;

    .max-exceeded {
        @include border-radius(3px);
        @include display-flex();
        @include justify-content();
        @include align-items();
        @include font-size(s);
        line-height: 1.2;
        text-align: center;
        color: #fff;
        background-color: $error;
        width: calc((#{$key-size} * 3) + (#{rem(12px)} * 3));
        height: rem(40px);
        margin: 0 auto;
        padding: 10px;
        overflow: hidden;
        transition: 0.2s;

        &.hide {
            height: 0px;
            padding: 0;
        }
    }

    .numpad-error {
        min-height: 1.5em !important;
        span {
            color: $color-error-500;
        }
    }

    .num-padtop {
        @include display-flex();
        @include justify-content();
        @include align-items();
        width: calc((#{$key-size} * 3) + (#{rem(12px)} * 3));
        height: $topkey-size;
        margin: 15px auto;

        .pin {
            @include border-radius(4px);
            @include font-size(xl);
            line-height: $topkey-size;
            text-align: center;
            font-family: $text;
            color: $main-text !important;
            height: $topkey-size;
            width: 100%;
            border: none;
            padding: 0;
            display: inline-block;

            background-color: #f9f9f9;
            color: $main-text !important;
            opacity: 1;

            &.new-desing {
                @include font-size(32px);
                font-family: $text-bold;
                text-transform: uppercase;
                color: #2C385C;
            }
        }

        &.has-quantity {
            .pin {
                width: calc(100% - #{$topkey-size * 2} - #{rem(12px) * 2});
            }
        }
        .password-pin {
            @include display-flex();

            .number-key {
                @include border-radius(100%);
                border: 2px solid $main-t80;
                margin-right: 9px;
                background-color: $neutro-t20;
                width: 60px;
                height: 60px;

                .circle {
                    border-radius: 50%;
                    background-color: $main;
                    width: 15px;
                    height: 15px;
                    opacity: 1;
                    margin: 0 auto;
                    animation: scaleIn 0.1s cubic-bezier(0.36, 0.11, 0.89, 0.32);
                }

                @keyframes scaleIn {
                    from {
                        transform: scale(1.5, 1.5);
                        opacity: 0.5;
                    }
                    to {
                        transform: scale(0.5, 0.5);
                        opacity: 0;
                    }
                }
                &.with-value {
                    @include display-flex();
                    @include align-items(center);
                    animation: 0.4s ease-in-out forwards;
                    border: 2px solid $main;
                }

                &.error-pin {
                    background-color: $error-t70;
                    border: 2px solid $error-t50;
                    animation: shake 0.5s;

                    @keyframes shake {
                        0% {
                            transform: translate(1px, 1px) rotate(0deg);
                        }
                        10% {
                            transform: translate(-1px, -2px) rotate(-1deg);
                        }
                        20% {
                            transform: translate(-3px, 0px) rotate(1deg);
                        }
                        30% {
                            transform: translate(3px, 2px) rotate(0deg);
                        }
                        40% {
                            transform: translate(1px, -1px) rotate(1deg);
                        }
                        50% {
                            transform: translate(-1px, 2px) rotate(-1deg);
                        }
                        60% {
                            transform: translate(-3px, 1px) rotate(0deg);
                        }
                        70% {
                            transform: translate(3px, 1px) rotate(-1deg);
                        }
                        80% {
                            transform: translate(-1px, -1px) rotate(1deg);
                        }
                        90% {
                            transform: translate(1px, 2px) rotate(0deg);
                        }
                        100% {
                            transform: translate(1px, -2px) rotate(-1deg);
                        }
                    }
                }
            }
        }
    }

    .num-pad {
        @include display-flex();
        @include flex-wrap($w: wrap);
        @include align-items();
        @include justify-content();
        width: calc((#{$key-size} * 3) + (#{rem(12px)} * 3));
        margin: 0 auto;
    }

    .key {
        @include interaction();
        @include display-flex();
        @include align-items();
        @include justify-content();
        @include border-radius(4px);
        @include font-size(l);
        font-family: $text-bold;
        color: $main-s20;
        width: $key-size;
        height: $key-size;
        margin: rem(6px);
        background-color: $inactive-t80;

        // @include bgHover($main-t90);
        &:active {
            cursor: pointer;
            animation: numpadClick 0.2s;
            @include bgHover($main-t80);
        }

        @keyframes numpadClick {
            0%,
            100% {
                transform: scale(1, 1);
            }
            25% {
                transform: scale(1.1, 1.1);
            }
            50% {
                transform: scale(1, 1);
            }
            75% {
                transform: scale(1.05, 1.05);
            }
        }

        &.keyback {
            @include background($image: img('undo_primary.svg'), $size: 25px);
            background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 472.615 472.615' style='enable-background:new 0 0 472.615 472.615;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cpath d='M139.569,96.738L0,236.307l139.569,139.57h333.046v-139.57V96.738H139.569z M362.673,305.637l-13.923,13.922 l-69.329-69.332l-69.33,69.332l-13.922-13.922l69.329-69.332l-69.329-69.332l13.922-13.923l69.33,69.332l69.329-69.332 l13.923,13.923l-69.33,69.332L362.673,305.637z' fill='%23475b96'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
        }
        &.disabled {
            @include opacity(0);
        }

        &.negative-positive {
            @include background($image: img('add_less.svg'), $size: 25px);
        }

        &.negative,
        &.positive {
            @include border-radius(100%);
            width: rem(40px);
            height: rem(40px);
            display: inline-block;
            position: absolute;
            padding: 6px;
            background-color: $main-t90;
            background-clip: content-box;
            transition-duration: 0.2s;

            &.selected {
                background-size: 16px;
                padding: 3px;
                background-color: transparent;
            }
            &.selected ~ .pin {
                padding-left: rem(40px);
            }
        }
        &.negative {
            @include background($size: 12px, $image: img('less_primary_dark.svg'));
        }
        &.positive {
            @include background($size: 12px, $image: img('more_primary_dark.svg'));
        }

        &.operator {
            @include background($size: 15px, $color: $neutro);
            width: $topkey-size;
            height: $topkey-size;
            display: inline-block;
            margin: 0 6px;

            @include bgHover($neutro);
        }
        &.less {
            background-image: img('less_primary.svg');
        }
        &.more {
            background-image: img('more_primary.svg');
        }
        &.save-and-close {
            background-color: $color-success-500;
            i[class^="i-andy-"] {
                color: $color-white;
            }

            &:hover {
                background-color: $color-success-800 !important;
            }
        }
    }

    .no-value {
        @include interaction();
        @include border-radius(3px);
        @include font-size(m);
        @include display-flex();
        @include align-items();
        @include justify-content();
        font-family: $text;
        color: $main-dark;
        height: rem(40px);
        // display: block;
        width: rem(165px);
        margin: rem(6px) auto;
        text-align: left;
    }

    .number-box {
        @include display-flex();
        @include flex-wrap($w: wrap);
        @include align-items();
        @include justify-content();
        position: relative;
        margin: 15px 0;
        width: 100%;

        .hint {
            @include font-size(s);
            margin-bottom: 5px;
            width: 100%;
            text-align: center;
            font-family: $text-light;
            color: $inactive-s20;

            b {
                color: $inactive-s20;
            }
        }

        .negative {
            margin-left: 0;

            &.selected {
                background-color: $main;
                color: #fff;
            }
        }
        .pin {
            @include border-radius(4px);
            @include font-size(xl);
            border: 2px solid #eee;
            height: 40px;
            width: calc((#{$key-size} * 3) + (#{rem(12px)} * 3));
            background-color: #f9f9f9;
            color: #666;
            text-align: center;
            padding: 24px 0;
            height: 52px;
        }

        .units {
            @include display-flex();
            @include align-items();
            @include justify-content();
            @include border-radius(4px);
            @include font-size(l);
            font-family: $text;
            color: $main-s20;
            width: $key-size;
            height: $key-size;
            margin: rem(6px);
        }
        .key {
            @include interaction();
            @include display-flex();
            @include align-items();
            @include justify-content();
            @include border-radius(4px);
            @include font-size(l);
            font-family: $text-bold;
            color: $main-s20;
            width: 52px;
            height: 52px;
            margin: rem(6px);
            background-color: $inactive-t80;
            position: relative;
            background-image: none;

            // @include bgHover($main-t90);
            &:active {
                cursor: pointer;
                animation: numpadClick 0.2s;
                @include bgHover($main-t80);
            }

            @keyframes numpadClick {
                0%,
                100% {
                    transform: scale(1, 1);
                }
                25% {
                    transform: scale(1.1, 1.1);
                }
                50% {
                    transform: scale(1, 1);
                }
                75% {
                    transform: scale(1.05, 1.05);
                }
            }

            &.keyback {
                @include background($image: img('undo_primary.svg'), $size: 25px);
                background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 472.615 472.615' style='enable-background:new 0 0 472.615 472.615;' xml:space='preserve' width='512px' height='512px'%3E%3Cg%3E%3Cg%3E%3Cpath d='M139.569,96.738L0,236.307l139.569,139.57h333.046v-139.57V96.738H139.569z M362.673,305.637l-13.923,13.922 l-69.329-69.332l-69.33,69.332l-13.922-13.922l69.329-69.332l-69.329-69.332l13.922-13.923l69.33,69.332l69.329-69.332 l13.923,13.923l-69.33,69.332L362.673,305.637z' fill='%23475b96'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
            }
            &.disabled {
                @include opacity(0);
            }
        }
    }

    @include small {
        $m-key-size: rem(65px);
        $m-topkey-size: rem(65px);

        .max-exceeded {
            width: calc((#{$m-key-size} * 3) + (#{rem(12px)} * 3));
        }
        .num-padtop {
            width: calc((#{$m-key-size} * 3) + (#{rem(12px)} * 3));
            height: $m-topkey-size;

            .pin {
                line-height: $m-topkey-size;
                height: $m-topkey-size;
            }
            &.has-quantity {
                .pin {
                    width: calc(100% - #{$m-topkey-size * 2} - #{rem(12px) * 2});
                }
            }
            .password-pin {
                @include display-flex();

                .number-key {
                    width: 55px;
                    height: 55px;
                    .circle {
                        border-radius: 50%;
                        background-color: $main;
                        width: 12px;
                        height: 12px;
                        opacity: 1;
                        margin: 0 auto;
                        animation: scaleIn 0.1s cubic-bezier(0.36, 0.11, 0.89, 0.32);
                    }

                    @keyframes scaleIn {
                        from {
                            transform: scale(1.5, 1.5);
                            opacity: 0.5;
                        }
                        to {
                            transform: scale(0.5, 0.5);
                            opacity: 0;
                        }
                    }
                    &.error-pin {
                        background-color: $error-t70;
                    }
                    &.with-value {
                        @include display-flex();
                        @include align-items(center);
                        animation: 0.4s ease-in-out forwards;
                        border: 2px solid $main;
                    }
                }
            }
            &.error-numpad {
                margin-top: 5px;
            }
        }
        .num-pad {
            width: calc((#{$m-key-size} * 3) + (#{rem(12px)} * 3));
        }
        .key {
            // width: $m-key-size;
            // height: $m-key-size;

            &.operator {
                width: $m-topkey-size;
                height: $m-topkey-size;
            }
        }
    }
    &.desktop {
        .key {
            @include bgHover($main-t90);
        }
    }
}
@media all and (orientation: portrait) {
    .numpad-content {
        width: 100%;
        height: auto;
        .num-padtop {
            width: auto;
            height: auto;

            .password-pin {
                @include justify-content();
                width: auto;
                height: auto;

                .number-key {
                    @include align-self(center);
                    width: 80px;
                    height: 80px;

                    .circle {
                        border-radius: 50%;
                        background-color: $main;
                        width: 20px;
                        height: 20px;
                        opacity: 1;
                        margin: 0 auto;
                        animation: scaleIn 0.1s cubic-bezier(0.36, 0.11, 0.89, 0.32);
                    }

                    @keyframes scaleIn {
                        from {
                            transform: scale(1.5, 1.5);
                            opacity: 0.5;
                        }
                        to {
                            transform: scale(0.5, 0.5);
                            opacity: 0;
                        }
                    }

                    &.error-pin {
                        animation: shake 0.5s;

                        @keyframes shake {
                            0% {
                                transform: translate(1px, 1px) rotate(0deg);
                            }
                            10% {
                                transform: translate(-1px, -2px) rotate(-1deg);
                            }
                            20% {
                                transform: translate(-3px, 0px) rotate(1deg);
                            }
                            30% {
                                transform: translate(3px, 2px) rotate(0deg);
                            }
                            40% {
                                transform: translate(1px, -1px) rotate(1deg);
                            }
                            50% {
                                transform: translate(-1px, 2px) rotate(-1deg);
                            }
                            60% {
                                transform: translate(-3px, 1px) rotate(0deg);
                            }
                            70% {
                                transform: translate(3px, 1px) rotate(-1deg);
                            }
                            80% {
                                transform: translate(-1px, -1px) rotate(1deg);
                            }
                            90% {
                                transform: translate(1px, 2px) rotate(0deg);
                            }
                            100% {
                                transform: translate(1px, -2px) rotate(-1deg);
                            }
                        }
                    }
                    &.with-value {
                        @include display-flex();
                        @include align-items(center);
                        animation: 0.4s ease-in-out forwards;
                        border: 2px solid $main;
                    }
                    // &.has-value {
                    //     background-size: 16px;
                    // }
                }
            }
        }

        .num-pad {
            width: calc(270px + 7.5px * 6);
            height: auto;
            overflow-x: hidden;

            .key {
                width: 90px;
                height: 90px;
            }
        }
    }
}
</style>

// PORTRAIT STYLES
<style lang="scss">
.numpad-container.portrait {
    @include display-flex();
    @include align-items();
    @include justify-content();
    @include flex-direction(column);
    // @include flex-wrap(wrap);
    max-width: calc(100%);
    overflow: auto;
    height: 100%;
    position: relative;
    width: 100%;

    .num-padtop {
        @include align-items(flex-start);
        max-width: 100%;
        width: 100%;
        // height: calc((90vw / 4) - 20px);
        max-height: 100px;
        max-height: unset;
        // height: clamp(calc((90vh / 4) - 40px), 20%, 200px);
        height: fit-content;
        padding-top: 8px;
        padding-bottom: 8px;

        .password-pin {
            @include display-inline-flex();
            @include align-items();
            @include justify-content();
            width: 100%;
            height: calc((100vw / 4) - 20px);
            max-height: 100px;

            .number-key {
                width: calc((90vw / 4) - 20px);
                height: calc((90vw / 4) - 20px);
                max-width: 75px;
                max-height: 75px;
                min-width: 55px;
                opacity: 1;

                .circle {
                    border-radius: 50%;
                    background-color: $main;
                    width: 18px;
                    height: 18px;
                    opacity: 1;
                    margin: 0 auto;
                    animation: scaleIn 0.2s cubic-bezier(0.36, 0.11, 0.89, 0.32);
                }

                @keyframes scaleIn {
                    from {
                        transform: scale(1.5, 1.5);
                        opacity: 0.5;
                    }
                    to {
                        transform: scale(0.5, 0.5);
                        opacity: 0;
                    }
                }

                &.with-value {
                    animation: 0.4s ease-in-out forwards;
                    border: 2px solid $main;
                }
            }
        }
    }

    .num-pad {
        @include flex-wrap(wrap);
        @include justify-content(space-between);
        width: 100%;
        // height: calc(100% - calc((100vh / 4) - 20px) - 14px);
        height: fit-content;
        position: relative;
        max-width: 300px;
        max-height: 375px;
        min-height: 225px;

        .key {
            @include font-size(sm);
            flex-shrink: 0;
            flex: 0 0 auto;
            width: calc((100% / 3) - 10px);
            padding: 0;
            line-height: 20%;
            // height: calc((100% / 4) - 10px);
            margin: 4px 0;
        }
    }
}
</style>

